module.exports = __webpack_public_path__ + "img/reverse.45103241.png";